import {LitElement, css, html} from "lit";

export class AuiOption extends LitElement {

	static get properties() {
		return {
			label: String,
			value: Object,

			isDisabled: { type: Boolean, attribute: "disabled", reflect: true },
			isFocused: { type: Boolean, attribute: "focused", reflect: true },
			isSelected: { type: Boolean, attribute: "selected", reflect: true },
		};
	}

	constructor() {
		super();
		this.label = null;
		this.value = null;

		this.isDisabled = false;
		this.isFocused = false;
		this.isSelected = false;
	}

	static get styles() {
		return css`
			:host {
				display: block;
				padding: 5px;
				cursor: pointer;
			}
			
			:host([focused]) {
				background: lightgrey;
			}
			
			:host([disabled]) {
				opacity: 0.5;
				pointer-events: none;
			}
			
			:host([selected]) {
				background: cornflowerblue;
			}
		`;
	}

	render() {
		return html`<div>${this.label}</div>`;
	}

}

customElements.define("aui-option", AuiOption);